import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';

import Environment from '../../../lib/Environment';
import { EventoXPlanilla } from '../../../system/EventoXPlanilla/EventoXPlanilla';
import { PlanillaPartido } from '../../../system/PlanillaPartido/PlanillaPartido';
import { TimeoutXPlanilla } from '../../../system/TimeoutXPlanilla/TimeoutXPlanilla';
import PlanillaDigitalForm from '../PlanillaDigitalForm';

export class PlanillaPartidoArchivoSincronizacion {
  private constructor(
    private environment: Environment,
    private planilla: PlanillaDigitalForm,
    private suspendido: boolean,
    private suspendidoTiempo: string
  ) {}

  static download(
    environment: Environment,
    planilla: PlanillaDigitalForm,
    suspendido: boolean,
    suspendidoTiempo: string = '00:00'
  ) {
    return new this(environment, planilla, suspendido, suspendidoTiempo).value();
  }

  value() {
    const payload = this.getPayload();
    const blob = this.generateFile(payload);
    this.downloadFile(blob);
  }

  private generateFile(payload: string) {
    const key = this.getRandomKey();
    const iv = this.getRandomKey();
    const encryptedText = CryptoJS.AES.encrypt(payload, CryptoJS.enc.Hex.parse(key), {
      iv: CryptoJS.enc.Hex.parse(iv),
    }).toString();
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(this.environment.publicKey());
    const encryptedKey = encrypt.encrypt(key) as string;
    const encryptedIv = encrypt.encrypt(iv) as string;
    return new Blob([`${encryptedKey}\n${encryptedIv}\n${encryptedText}`]);
  }

  private getPayload() {
    const listEvents = [...this.planilla.getPlanillaEventoInput().getValue()] as EventoXPlanilla[];
    const listTimeouts = [...this.planilla.getTimeoutXPlanillaInput().getValue()] as TimeoutXPlanilla[];

    const jsonData = {
      events: listEvents.map((e) => e.toJSON()),
      timeouts: listTimeouts.map((e) => e.toJSON()),
      planillaPartido: this.getPlanillaPartido().toJSON(),
      suspendido: this.suspendido,
      suspendidoTiempo: this.suspendidoTiempo,
    };
    return JSON.stringify(jsonData);
  }

  private downloadFile(blob: Blob) {
    try {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = this.getFilename();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  }

  private getFilename() {
    const planillaPartido = this.getPlanillaPartido();
    const partido = planillaPartido.getPartido();
    const torneo = partido.getTorneo();

    const local = partido.getLocal()?.getClub()?.getNombre();
    const visita = partido.getVisitante()?.getClub()?.getNombre();
    const torneoNombre = torneo?.getNombre();
    const categoria = torneo?.getCategoria()?.getNombre();
    const rama = torneo?.getRama();
    const division = torneo?.getDivision()?.getNombre();

    const forbiddenChars = /[<>:"\/\\|?*\x00-\x1F]/g;
    return `${local}-vs-${visita}-${torneoNombre}-${categoria}-${rama}-${division}`.replace(
      forbiddenChars,
      '_'
    );
  }

  private getRandomKey() {
    return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
  }

  private getPlanillaPartido() {
    return this.planilla.getPlanillaPartidoInput().getValue() as PlanillaPartido;
  }
}
